export default {
  language: { label: 'Language', en: 'English', de: 'Deutsch' },
  analytics: { ariaLabel: 'Analytics consent', title: 'Analytics cookies', description: 'With your consent, we use Google Analytics to understand how No Context Games is used. Details are available in the privacy policy.', decline: 'Decline', accept: 'Accept' },
  nav: { allGames: 'All games', joinRoom: 'Join room', back: 'Back', close: 'Close', main: 'Main navigation' },
  status: { live: 'Live', reconnecting: 'Reconnecting', waitingForHost: 'Waiting for the host', host: 'Host' },
  room: { room: 'Room', roomCode: 'Room code', inviteCode: 'Invite code' },
  game: { round: 'Round {{current}} / {{total}}', players: '{{count}} / 8 players joined' },
  actions: { next: 'Next', shareInvite: 'Share invite', copied: 'Copied!', copyRoomLink: 'Copy room link', playAgain: 'Play again', remove: 'Remove {{name}}', mute: 'Mute sound', soundOn: 'Turn sound on' },
  loading: {
    connecting: 'Connecting to the game…',
    failedTitle: 'Fresh files needed',
    failedMessage: 'Your browser kept an older game file. Reload once to fetch the current version.',
    retry: 'Reload game',
  },
  errors: {
    TIMEOUT: 'The game server did not respond. Check your connection and try again.',
    SERVER_ERROR: 'Something went wrong. Please try again.',
    INVALID_NAME: 'Names must be between 2 and 20 characters.',
    NAME_TAKEN: 'Someone in this room already has that name.',
    ROOM_NOT_FOUND: 'We could not find that room.',
    ROOM_FULL: 'This room is full.',
    GAME_STARTED: 'This game has already started.',
    NOT_ENOUGH_PLAYERS: 'At least three players are required.',
    BAD_PHASE: 'That action is not available right now.',
    NOT_ALLOWED: 'You cannot perform that action.',
    PLAYER_NOT_FOUND: 'That player is no longer in the room.',
    INVALID_FACTS: 'Enter three different statements between 3 and 120 characters.',
    INVALID_GLITCH: 'Choose which statement is the glitch.',
    NOT_SUBJECT: 'It is not your turn to submit.',
    ALREADY_VOTED: 'Your vote is already locked in.',
    INVALID_REASON: 'Choose one of the reasons on the ballot.',
    WAITING_FOR_VOTES: 'Wait for every anonymous ballot.',
    NOT_SPOTLIGHT: 'Only the person on the spot can choose the angle.',
    STANCE_LOCKED: 'Your angle is already locked in.',
    INVALID_STANCE: 'Choose whether to own it or object.',
    WAITING_FOR_STANCE: 'The person on the spot must choose an angle first.',
    NOT_GUEST: 'Only tonight’s guest can make that choice.',
    INVALID_CRAVING: 'Choose one of the cravings on the private menu.',
    GUEST_CANNOT_COOK: 'The guest is ordering, not cooking.',
    DISH_SUBMITTED: 'Your dish is already on the pass.',
    INVALID_BASE: 'Choose a plate from this kitchen.',
    INVALID_TWIST: 'Choose a finish from this kitchen.',
    WAITING_FOR_DISHES: 'Wait for every chef to plate a dish.',
    INVALID_DISH: 'Choose a dish from tonight’s secret menu.',
    ORDER_LOCKED: 'The guest order is already locked in.',
    GUEST_CANNOT_BET: 'The guest places the order instead.',
    BET_LOCKED: 'Your table bet is already locked in.',
    WAITING_FOR_TASTING: 'Wait for the guest order and every table bet.',
    NOT_PLAYING: 'You are not part of this game.',
    NOT_CALLER: 'Only the current caller can do that.',
    DILEMMA_SUBMITTED: 'This dilemma is already on file.',
    INVALID_NEED: 'Choose what you honestly need from the room.',
    INVALID_DILEMMA: 'Your dilemma must be between 12 and 180 characters.',
    CALLER_CANNOT_ADVISE: 'The caller cannot answer their own dilemma.',
    ADVICE_SUBMITTED: 'Your advice is already on file.',
    INVALID_ADVICE_TEXT: 'Bad advice must be between 12 and 160 characters.',
    INVALID_FINE_PRINT: 'Fine print must be between 8 and 140 characters.',
    WAITING_FOR_ADVICE: 'Wait for every advisor to file an answer.',
    INVALID_ADVICE: 'Choose advice from this case file.',
    ADVICE_SELF_VOTE: 'You cannot assign liability to your own advice.',
    TEMPTATION_LOCKED: 'Your guilty choice is already locked in.',
    INVALID_TACTIC: 'Choose a malpractice tactic.',
    WAITING_FOR_VERDICTS: 'Wait for every liability stamp and the caller’s guilty choice.',
    NOT_SENDER: 'Only the current sender can do that.',
    DRAFT_SUBMITTED: 'This message is already in the multiverse.',
    INVALID_UNSENT_REASON: 'Choose why the message stayed unsent.',
    INVALID_RECIPIENT: 'The recipient label must be between 2 and 30 characters.',
    INVALID_MESSAGE: 'The message must be between 12 and 220 characters.',
    SENDER_CANNOT_REPLY: 'The sender cannot answer their own message.',
    REPLY_SUBMITTED: 'Your timeline is already saved.',
    INVALID_REPLY: 'The reply must be between 8 and 180 characters.',
    INVALID_AFTERSHOCK: 'The consequence must be between 8 and 140 characters.',
    WAITING_FOR_REPLIES: 'Wait for every parallel reply.',
    INVALID_TIMELINE: 'Choose a reply from this inbox.',
    SENDER_CANNOT_VOTE: 'The sender opens a timeline instead.',
    UNSENT_SELF_VOTE: 'You cannot boost your own timeline.',
    TIMELINE_OPENED: 'You already opened a timeline.',
    WAITING_FOR_INBOX: 'Wait for every signal vote and the sender’s choice.',
    INVALID_UNSENT_DECISION: 'Choose whether to keep or reroute the timeline.',
    SAME_TIMELINE: 'Reroute to a different timeline.',
    WAITING_FOR_REROUTE: 'Wait for the sender to resolve the timeline.',
    SUBJECT_CANNOT_VOTE: 'The storyteller cannot vote.',
    INVALID_VOTE: 'That choice is not available.',
    ALREADY_SUBMITTED: 'Your pitch is already in the boardroom.',
    INVALID_PRODUCT_NAME: 'Product names must be between 3 and 40 characters.',
    INVALID_PITCH: 'Your pitch must be between 10 and 180 characters.',
    SELF_VOTE: 'Even CEOs cannot vote for themselves.',
    NOT_ENOUGH_PITCHES: 'At least two pitches are needed to vote.',
    ANSWER_LOCKED: 'Your answer is already locked.',
    ABILITY_USED: 'You already used your gadget.',
    INVALID_ROLE: 'Your crew role could not be found.',
    ROLE_LOCKED: 'Your crew role is already locked.',
    NO_GADGET_CHARGES: 'You have no moves left.',
    INVALID_TARGET: 'Choose another player in this heist.',
    INVALID_ANSWER: 'That answer is not available.',
    NO_ANSWERS: 'Wait for at least one answer before cracking the vault.',
    INVALID_ALIBI: 'Your alibi must be between 8 and 160 characters.',
    NOT_ENOUGH_ALIBIS: 'At least two alibis are needed for questioning.',
    CULPRIT_CANNOT_VOTE: 'The culprit must identify the evidence instead.',
    NOT_CULPRIT: 'Only the culprit can identify the evidence.',
    ALREADY_GUESSED: 'Your evidence guess is already locked in.',
    INVALID_EVIDENCE: 'Choose a piece of evidence from this case.',
    INVALID_SUSPECT: 'Choose someone in the club.',
    ALIBI_SUBMITTED: 'Your statement is already on file.',
    SELF_ACCUSATION: 'You know you did not do it. Accuse somebody else.',
    INVALID_DRAWING: 'That drawing contains too much ink or invalid marks. Undo a few strokes and try again.',
    DRAWING_SUBMITTED: 'That drawing is already locked in.',
    NOT_ENOUGH_DRAWINGS: 'At least two drawings are needed to continue.',
    SELF_RESCUE_VOTE: 'You cannot award the rescue on your own invention.',
    SELF_SABOTAGE_VOTE: 'You cannot award your own sabotage.',
    INVALID_LIVE_ACTION: 'That console movement was not valid. Try the next signal call.',
    ACTION_WINDOW_CLOSED: 'That signal window has already closed.',
    ACTION_LOCKED: 'Your response to that call is already locked.',
    NO_ACTIVE_SIGNAL: 'Wait for an active signal call before using the emergency board.',
    NO_SIGNAL_CHARGES: 'Your emergency board has no charges left.',
    WRONG_GAME: 'That room belongs to a different game.',
    WRONG_MODE: 'This room is controlled from the host player’s phone.',
    INVALID_MODE: 'Choose a valid way to play.',
    INVALID_GAME: 'Choose a valid game.',
    missingSession: 'Your player session is missing. Join the room again.',
    hostSessionMissing: 'The host key for this room is missing.',
  },
}
